import { Component,createRef } from 'react';
import './Button.scss';
import Loader from "react-loader-spinner";


class Button extends Component{
    constructor(props) {
        super(props);
        this.state = {
            hasParentCardContainer: false
        };
        this.buttonRef = createRef();
    }

    componentDidMount() {
        if (this.hasParentCardContainer()) {
            this.setState({ hasParentCardContainer: true });
        }
    }

    hasParentCardContainer() {
        let currentNode = this.buttonRef.current;
        while (currentNode) {
            if (currentNode.classList.contains('car-card--content-item')) {
                return true;
            }
            currentNode = currentNode.parentElement;
        }
        return false;
    }
    render(){
        return (<>
            <button   ref={this.buttonRef} type={this.props.type} className={`button ${this.props.className} ${this.props.loading?'loading':''}`} onClick={this.props.onClick}>
                {
                    this.props.loading? 
                    <div className="loader-container">
                        <Loader type="ThreeDots" color="#e3e3e3" height={this.props.loaderHeight || 40} width={ this.props.loaderWidth || 50}/>
                    </div>:
                   <span>{this.props.children}</span>
                }
            </button>
        </>)
    }
}
export default Button;